export const CUSTOMER_SERVICE_ORGANIZATIONS_ROUTE = "/organizations";

export const CUSTOMER_SERVICE_ORGANIZATION_ROUTE = `${CUSTOMER_SERVICE_ORGANIZATIONS_ROUTE}/:organizationId` as const;

export const customerServiceOrganizationPath = (organizationId: string): string =>
  `${CUSTOMER_SERVICE_ORGANIZATIONS_ROUTE}/${encodeURIComponent(organizationId)}`;

export const CUSTOMER_SERVICE_LEARNING_GRANTS_SEGMENT = "learning-grants";

export const customerServiceLearningGrantsPath = (organizationId: string): string =>
  `${customerServiceOrganizationPath(organizationId)}/${CUSTOMER_SERVICE_LEARNING_GRANTS_SEGMENT}`;

// Route splats keep a trailing slash ("learning-grants/") that route matching ignores.
export const isCustomerServiceLearningGrantsSubPath = (subPath: string | undefined): boolean =>
  subPath?.replace(/\/+$/, "") === CUSTOMER_SERVICE_LEARNING_GRANTS_SEGMENT;
